import { useMemo } from "react";

/**
 * Generate a device fingerprint based on browser characteristics
 * 
 * NOTE: This is NOT cryptographically secure and can be spoofed.
 * It's used in combination with session binding to detect cookie theft.
 */
export const useDeviceFingerprint = (): string => {
  return useMemo(() => {
    const { userAgent, language, platform } = navigator;
    const { width, height, colorDepth } = screen;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    
    const fingerprintData = `${userAgent}-${language}-${platform}-${width}x${height}-${colorDepth}-${timezone}`;
    
    return btoa(fingerprintData);
  }, []);
};

export const getCurrentDeviceFingerprint = (): string => {
  const { userAgent, language, platform } = navigator;
  const { width, height, colorDepth } = screen;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
  return btoa(`${userAgent}-${language}-${platform}-${width}x${height}-${colorDepth}-${timezone}`);
};

export const getCurrentDeviceName = (): string => {
  return navigator.userAgent.substring(0, 200);
};
